import { Trans } from "react-i18next";

const DownloadLink = ({ className = "", link }) => (
  <Trans
    components={{ button: <a {...{ className }} href={link} /> }}
    i18nKey="neetoMolecules.browserSupport.downloadLink.main"
  />
);

export default DownloadLink;
